import { ContactUsFeatures } from '../../model/contact-us/contact-us.model';

export const SIZE_OPTIONS = ['1-99', '100-999', '1000-4999', '5000+'];

export const CONTACT_US_FEATURES: ContactUsFeatures = {
  title: $localize`:@@contactUsData.title:Seeking the best solutions for your industrial needs?`,
  features: [
    $localize`:@@contactUsData.features.1:Assisting you is our top priority`,
    $localize`:@@contactUsData.features.2:We have the resources and knowledge to meet your specific requirements`,
    $localize`:@@contactUsData.features.3:We can create solutions tailored to your company's needs`
  ]
};
